// compression utisl
import { gzipSync, gunzipSync, strToU8, strFromU8 } from "fflate";

// const ENCODE = "base64";

// Compress object to base64 string
export const objectCompression = (object: any): string => {
  const json = JSON.stringify(object);
  const compressed = gzipSync(strToU8(json));
  const base64 = btoa(String.fromCharCode(...Array.from(compressed)));
  return base64;
};

// Decompress base64 string back to object
export const objectDecompress = (compressedString: string): any => {
  const binary = atob(compressedString);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  const decompressed = strFromU8(gunzipSync(bytes));
  return JSON.parse(decompressed);
};
